(() => {
  'use strict';

  angular
    .module('uwAgenda.agenda')
    .controller(
      'AgendaAppointmentExternalPatientSelectionModalController',
      [
        '$uibModalInstance',
        '$localStorage',
        '$rootScope',
        'ExternalPatientBroadcast',
        'phoneNumber',
        AgendaAppointmentExternalPatientSelectionModalController
      ]);

  function AgendaAppointmentExternalPatientSelectionModalController(
    $uibModalInstance,
    $localStorage,
    $rootScope,
    ExternalPatientBroadcast,
    phoneNumber) {
    const vm = this;

    vm.phoneNumber = phoneNumber;
    vm.patients = $localStorage.ExternalPatientSearchResult;

    if ($localStorage.ExternalPatientIncomingData)
    {
      vm.firstName = $localStorage.ExternalPatientIncomingData.firstName;
      vm.lastName = $localStorage.ExternalPatientIncomingData.lastName;
    }

    vm.selectPatient = function(patient) {
      $localStorage.ExternalPatientSearchResult = [patient];
      $rootScope.$broadcast(ExternalPatientBroadcast.set);
      $uibModalInstance.close({
        selectedPatient: patient,
        autoFillPatientName: false
      });
    }

    vm.close = function (autoFillPatientName) {
      $uibModalInstance.close({
        selectedPatient: null,
        autoFillPatientName: autoFillPatientName
      });
    };
  }
})();
